export class MultipleChoiceQuiz {
    constructor(isRandomize, data) {
        this._isRandomize = isRandomize;
        this._data = data;
    }
    getQuestion() {
        return "";
    }
    getOptions() {
        return [];
    }
}
